// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"453":"75087320","514":"9bae5ffd","556":"82483202","622":"a66ef288","896":"08c0f25e"}[chunkId] + ".chunk.js";
};